import { type NavigateOptions, useLocation, useNavigate } from "react-router";
import { useCustomerAppConfig } from "undercarriage";

const MiniSpaRoutes = {
  CompanyCreation: "company-creation",
  FinancialOS: "financial-os",
  FundingApp: "funding-app",
  FundingRequest: "funding-request",
  Banking: "banking",
  VerifyBusiness: "verify-business",
  Financing: "financing",
};

type UseSpaNavigateKey = keyof typeof MiniSpaRoutes;

export const useSpaNavigate = (key: UseSpaNavigateKey) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  //simple map keyed by spa namespaces to the appropriate basename
  const spaBasenames = {
    "company-creation": "/company-creation",
    "financial-os": `${customerDomain}/financial-os`,
    "funding-app": `/${customerDomain}/funding/application`,
    "funding-request": `/${customerDomain}/financing/funds-request`,
    banking: `/${customerDomain}/banking`,
    "verify-business": `/${customerDomain}/verify-business`,
    financing: `/${customerDomain}/financing`,
  };

  // to be used with the likes of using Links
  const prefixRouteWithBasename = (path: string) => {
    const basePath = `${spaBasenames[MiniSpaRoutes[key]]}/`;
    const combinedPath = basePath + path;
    const normalizedPath = combinedPath.replace(/\/{2,}/g, "/"); // Remove potential double forward slashes
    return normalizedPath;
  };

  // to be used in place of react router doms navigate function when routing within current spa
  const spaNavigate = (path: string, options?: NavigateOptions) => {
    navigate(prefixRouteWithBasename(path), options);
  };

  const getIsPathMatching = (href: string) => {
    const pathnameWithoutBasename = pathname.replace(spaBasenames[MiniSpaRoutes[key]], "");
    return pathnameWithoutBasename === href;
  };

  return {
    navigate: spaNavigate,
    getIsPathMatching,
    spaRoute: prefixRouteWithBasename,
    spaBasename: spaBasenames[MiniSpaRoutes[key]],
  };
};
